<template>
    <v-alert :value="visible" type="error" class="shape cutie text-caption">
        <slot />
    </v-alert>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

// 作りの違い的にはAlertErrorの名前の方を変えるべきだが利用箇所が多すぎるので保留
@Component({
    name: 'AlertErrorSimple',
})
export default class AlertErrorSimple extends Vue {
    @Prop({ default: true }) visible: boolean;
}
</script>
